export default __webpack_public_path__ + "static/media/lightBlueArrow.754eb5d5.svg";